/**
 * Pushes data to GTM's dataLayer
 * @param data
 */
export const push = (data) => {
  const dataLayer = window.dataLayer || []
  dataLayer.push(data)
}
